import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ISearchEmployeeApprovers} from '@employee-models/common.models';

@Component({
    selector: 'employee-chips',
    templateUrl: './employee-chips.component.html',
    styleUrls: ['./employee-chips.component.less']
})
export class EmployeeChipsComponent implements OnInit {
    @Input() chipsList: Array<ISearchEmployeeApprovers>;
    @Output() updateList = new EventEmitter<Array<ISearchEmployeeApprovers>>();

    constructor() {
    }

    ngOnInit(): void {
    }

    removeChip(chip: ISearchEmployeeApprovers): void {
        this.chipsList = this.chipsList.filter(item => item?.userId !== chip?.userId);
        this.updateList.emit(this.chipsList);
    }

}
